import styled from 'styled-components';
import { QRCodeSVG } from 'qrcode.react';
import tinycolor from 'tinycolor2';
import { KIOSK_PRO_MEDIA } from '../../kiosk-pro-shared/kiosk-pro-shared.styles';

export const QrCodeContainer = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 36px;
  background-color: ${({ theme }) => theme.colors.white};

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    gap: 28px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    gap: 24px;
  }
`;

export const QrCodeContent = styled(QRCodeSVG)`
  border: 6px solid ${({ theme }) => tinycolor.mix(theme.customized.colors.buttonsLinks, '#fff', 90).toString()};
  border-radius: 14px;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    height: 156px;
    width: 156px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    width: 112px;
    height: 112px;
  }
`;

export const QrcodeSubtitle = styled.p`
  color: ${({ theme }) => theme.colors.grey[30]};
  font-size: 24px;
  font-weight: 700;
  text-align: center;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    font-size: 20px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    font-size: 16px;
    font-weight: 600;
  }
`;
